import { object, string, number } from 'yup';

import { PHONE_REGEX } from '../../../../helpers/validation.helpers';
import { CountryAddressField, TCountry } from '../../../../store/countries/countries.types';

import { IShippingFormFields, ShippingAddressField } from './shipping.types';

const addressValidationFields = {
  [ShippingAddressField.Address]: string().default('').trim().required().min(3).max(255),
  [ShippingAddressField.Address2]: string().default('').trim().max(255),
  [ShippingAddressField.City]: string()
    .default('')
    .trim()
    .when('country', {
      is: country => country?.validation.optionalFields.includes(CountryAddressField.City),
      then: string().notRequired(),
      otherwise: string().required().min(1),
    })
    .max(255),
  [ShippingAddressField.State]: string()
    .default('')
    .trim()
    .when('country', {
      is: country =>
        country?.states?.length > 0 && !country?.validation.optionalFields.includes(CountryAddressField.State),
      then: string().required(),
      otherwise: string().notRequired(),
    }),
  [ShippingAddressField.Zipcode]: string()
    .default('')
    .trim()
    .when('country', {
      is: country => country?.validation.optionalFields.includes(CountryAddressField.PostalCode),
      then: string().notRequired(),
      otherwise: string().required(),
    })
    .max(10),
  [ShippingAddressField.Company]: string().default('').trim(),
  [ShippingAddressField.Phone]: string()
    .default('')
    .trim()
    .when('country', {
      is: country => country?.validation.optionalFields.includes(CountryAddressField.Phone),
      then: string().notRequired(),
      otherwise: string().required(),
    })
    .min(10)
    .matches(PHONE_REGEX, {
      message: 'Please enter a valid phone number.',
      excludeEmptyString: true,
    })
    .max(25),
  [ShippingAddressField.Country]: object().nullable().default(null).shape({ id: number().required() }).required(),
};

export const addressValidationSchema = object().shape(addressValidationFields);

export const getAddressDefaultValues = (country?: TCountry): IShippingFormFields =>
  addressValidationSchema.cast({ country }) as IShippingFormFields;
